import React from 'react';
import {
  Box,
  Flex,
  Text,
  Badge,
  Collapse,
  IconButton,
  useDisclosure,
  useBreakpointValue,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

const NetworkSectionCard = ({
  step,
  title,
  description,
  children,
  isComplete,
  defaultOpen = true,
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: defaultOpen });

  const header = (
    <Flex align="flex-start" gap={3} w="full">
      {step != null && (
        <Flex
          align="center"
          justify="center"
          flexShrink={0}
          w="28px"
          h="28px"
          borderRadius="full"
          bg={isComplete ? 'yellow.400' : 'gray.600'}
          color={isComplete ? 'black' : 'white'}
          fontSize="sm"
          fontWeight="bold"
        >
          {step}
        </Flex>
      )}
      <Box flex="1" minW={0} textAlign="left">
        <Flex align="center" gap={2} flexWrap="wrap">
          <Text fontWeight="semibold" fontSize={{ base: 'md', md: 'lg' }}>
            {title}
          </Text>
          {isComplete && (
            <Badge colorScheme="green" fontSize="2xs" variant="subtle">
              Completato
            </Badge>
          )}
        </Flex>
        {description && (
          <Text fontSize="sm" color="gray.400" mt={0.5}>
            {description}
          </Text>
        )}
      </Box>
      {isMobile && (
        <IconButton
          aria-label={isOpen ? 'Chiudi sezione' : 'Apri sezione'}
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          size="sm"
          variant="ghost"
          color="gray.300"
          onClick={onToggle}
          flexShrink={0}
        />
      )}
    </Flex>
  );

  return (
    <Box
      bg="#36393f"
      borderRadius="12px"
      borderWidth="1px"
      borderColor="gray.600"
      overflow="hidden"
    >
      <Box
        px={{ base: 4, md: 5 }}
        py={{ base: 3, md: 4 }}
        borderBottomWidth={isMobile && !isOpen ? 0 : '1px'}
        borderColor="gray.600"
        sx={{ bg: 'rgba(0, 0, 0, 0.12)' }}
        cursor={isMobile ? 'pointer' : 'default'}
        onClick={isMobile ? onToggle : undefined}
        role={isMobile ? 'button' : undefined}
        tabIndex={isMobile ? 0 : undefined}
        onKeyDown={
          isMobile
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onToggle();
                }
              }
            : undefined
        }
      >
        {header}
      </Box>
      {isMobile ? (
        <Collapse in={isOpen} animateOpacity>
          <Box px={{ base: 4, md: 5 }} py={{ base: 4, md: 5 }}>
            {children}
          </Box>
        </Collapse>
      ) : (
        <Box px={{ base: 4, md: 5 }} py={{ base: 4, md: 5 }}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default NetworkSectionCard;
